import { get } from '@/helpers/httpHandler';
import { echo, defaultChannel } from '@/helpers/pusher';

export default {
  getQuantityNewReservations({ commit }) {
    return get(`/booking/reservations/count-new-reservations`).then(
      response => {
        commit('setNewReservations', response.data.data.new_reservations);
        return response;
      }
    );
  },

  getActualQuantityNewReservations({ commit }) {
    echo
      .channel(defaultChannel)
      .listen('.App\\Events\\Reservation\\CountNewReservations', function(
        data
      ) {
        commit('setNewReservations', data.new_reservations);
      });
  }
};
